export default "__VITE_ASSET__DWfbe7UA__"